import { CircleCheck, CircleX } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function WorkableBadge({
	workable,
	className,
}: {
	workable: boolean;
	className?: string;
}) {
	return (
		<Badge variant={workable ? "success" : "warning"} className={className}>
			{workable ? <CircleCheck /> : <CircleX />}
			{workable ? "Operação OK" : "Risco"}
		</Badge>
	);
}
